/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".content-title[_ngcontent-%COMP%]{vertical-align:middle;font-size:20px;height:50px;line-height:50px;border-bottom:5px solid #000;background:#1f373f;border-top:1px solid #fff;border-top-right-radius:10px;color:#fff;padding-left:20px}\n/*# sourceMappingURL=section-title.component.css.map*/"];
export { styles as styles };
